import type { ManagementTranslations } from '../en-US/management.translations';

export const managementTranslations: ManagementTranslations = {
  title: 'Gestión de BiteCritic',
  dashboard: 'Panel de Control',
  users: 'Gestión de Usuarios',
  settings: 'Configuración',
  foods: {
    title: 'Gestión de Alimentos',
    createNew: 'Añadir Nuevo Alimento',
    id: 'ID',
    name: 'Nombre',
    category: 'Categoría',
    country: 'País',
    status: 'Estado',
    createdAt: 'Creado el',
    actions: 'Acciones',
    noFoodsFound: 'No se encontraron alimentos',
    searchPlaceholder: 'Buscar alimentos...',
    allStatuses: 'Todos los Estados',
    allCategories: 'Todas las Categorías',
    sortNewest: 'Más Recientes Primero',
    sortOldest: 'Más Antiguos Primero',
    sortNameAZ: 'Nombre A-Z',
    sortNameZA: 'Nombre Z-A',
    showing: 'Mostrando {{from}} a {{to}} de {{total}} alimentos',
    confirmDelete: '¿Está seguro de que desea eliminar este alimento?',
    approve: 'Aprobar',
    reject: 'Rechazar',
    createFood: 'Crear Nuevo Alimento',
    editFood: 'Editar Alimento',
    viewFood: 'Ver Detalles del Alimento',
    namePlaceholder: 'Introducir nombre del alimento',
    descriptionPlaceholder: 'Introducir descripción del alimento',
    selectCategory: 'Seleccionar una categoría',
    selectCountry: 'Seleccionar un país',
    selectStatus: 'Seleccionar un estado',
    imageUrl: 'URL de la imagen',
    imageUrlPlaceholder: 'Introducir URL de la imagen',
    imagePreview: 'Vista previa de la imagen',
    rowsPerPage: '{{count}} por página',
    translations: 'Traducciones',
    description: 'Descripción',
    formatJson: 'Formatear JSON',
    jsonPlaceholder: 'Introducir datos del alimento en formato JSON',
    jsonInstructions: 'Instrucciones de Formato JSON',
    jsonInstructionName:
      'El nombre es obligatorio y debe ser una cadena de texto',
    jsonInstructionCategory: 'CategoryId es obligatorio y debe ser un número',
    jsonInstructionCountry: 'CountryId es opcional y debe ser un número',
    jsonInstructionStatus: 'El estado debe ser uno de',
    jsonInstructionTranslations:
      'Las traducciones deben ser un registro de códigos de idioma a objetos de traducción',
    jsonUpdateError: 'Error al actualizar {{field}}: {{error}}',
    hideFilters: 'Ocultar Filtros',
    showFilters: 'Mostrar Filtros',
    totalItems: '{{count}} elementos en total',
    aiPrompt: {
      title: 'Generar Datos de Alimentos con IA',
      description: 'Usar IA para ayudar a generar datos de alimentos',
      inputLabel: 'Nombre del Alimento',
      inputPlaceholder: 'Introducir un nombre de alimento',
      buttonText: 'Generar con IA',
      copyPrompt: 'Copiar Prompt',
      openInChatGPT: 'Abrir en ChatGPT',
      promptCopied: '¡Prompt copiado al portapapeles!',
      instructions: 'Instrucciones:',
      step1: '1. Introducir un nombre de alimento',
      step2: '2. Hacer clic en "Generar con IA" o copiar el prompt',
      step3: '3. Pegar el prompt en ChatGPT o hacer clic en "Abrir en ChatGPT"',
      step4:
        '4. Copiar la respuesta JSON y usarla para crear un nuevo elemento de alimento',
    },
  },
  languages: {
    en: 'Inglés',
    nl: 'Holandés',
    tr: 'Turco',
    de: 'Alemán',
    fr: 'Francés',
    es: 'Español',
    it: 'Italiano',
    pt: 'Portugués',
  },
};

export default managementTranslations;
